import React from "react"
import Img from "gatsby-image"

import Container from "react-bootstrap/Container"
import Carousel from "react-bootstrap/Carousel"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"

import { TiStar } from "react-icons/ti"
import { BsChevronCompactLeft, BsChevronCompactRight } from "react-icons/bs"

const Testimonials = ({ lang, testimonials }) => {
  return (
    <section className="carousel py-5 carousel-section">
      <Container fluid={true} className="my-5">
        <div className="h2 mb-5 text-center text-uppercase">
          {lang === "ru" ? "Отзывы" : "Відгуки"}
        </div>
        <Row>
          <Carousel
            indicators={false}
            controls={true}
            touch={true}
            fade={false}
            nextIcon={<BsChevronCompactRight />}
            prevIcon={<BsChevronCompactLeft />}
          >
            {testimonials.map(testimonial => (
              <Carousel.Item
                key={testimonial.id}
                itemProp="review"
                itemScope={true}
                itemType="https://schema.org/Review"
              >
                <Col lg={{ span: 6, offset: 3 }} md={12} sm={12}>
                  <div className="testimonial-author text-center mb-2">
                    <span
                      itemProp="author"
                      itemScope={true}
                      itemType="https://schema.org/Person"
                    >
                      <span itemProp="name">{testimonial.clienName}</span>
                    </span>
                    {lang === "ru"
                      ? " оставил отзыв компании "
                      : " залишив відгук компанії "}
                    <span
                      itemProp="itemReviewed"
                      itemScope={true}
                      itemType="https://schema.org/LegalService"
                    >
                      <span itemProp="name">
                        {lang === "ru"
                          ? " Центр Лицензий "
                          : " Центр Ліцензій "}
                      </span>
                      <meta itemProp="@id" content="https://лицензии.укр" />
                      <meta
                        itemProp="address"
                        content={
                          lang === "ru"
                            ? "03164, Киев, Украина, ул. Подлесная, 1, оф. 8"
                            : "03164, м. Київ, Україна, вул. Підлісна, 1, оф. 8"
                        }
                      />
                    </span>
                    <meta
                      itemProp="datePublished"
                      content={testimonial.absolutedate}
                    />
                    <span className="from-now">{testimonial.fromdate}</span>
                    {lang === "ru" ? " с оценкой " : " з оцінкою "}
                    <span
                      itemProp="reviewRating"
                      itemScope={true}
                      itemType="https://schema.org/Rating"
                    >
                      <span itemProp="ratingValue">{testimonial.stars}</span>
                    </span>
                    .
                  </div>
                  <div className="star-rating d-flex justify-content-center mb-4">
                    <TiStar />
                    <TiStar />
                    <TiStar />
                    <TiStar />
                    <TiStar />
                  </div>
                  <p className="text-center" itemProp="reviewBody">
                    {testimonial.text.text}
                  </p>
                  <span
                    itemProp="publisher"
                    itemScope={true}
                    itemType="https://schema.org/Organization"
                  >
                    <meta itemProp="name" content="Google My Business" />
                  </span>
                  <div className="d-flex justify-content-center w-100">
                    <Img
                      fixed={testimonial.screen.fixed}
                      title={
                        lang === "ru"
                          ? `скрин отзыва от ${testimonial.clienName}`
                          : `скріншот відгуку від ${testimonial.clienName}`
                      }
                      alt={
                        lang === "ru"
                          ? `отзыв от ${testimonial.clienName}`
                          : `відгук від ${testimonial.clienName}`
                      }
                    />
                  </div>
                </Col>
              </Carousel.Item>
            ))}
          </Carousel>
        </Row>
      </Container>
    </section>
  )
}

export default Testimonials
